import React, {Component} from "react"

import {List, SearchField} from "~/components/"
import {withTranslation} from "react-i18next"

class SearchableList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      query: ""
    }
  }

  onChange(query) {
    this.setState({query: query})
  }

  render() {
    return (
      <div className="sh-searchable-list">
        <div className="searchbar">
          {this.props.renderSearchbar
            ? this.props.renderSearchbar()
            : this.renderSearchbar()}

          {this.props.renderActions ? this.props.renderActions() : null}
        </div>

        <div className="results">
          <List
            items={this.props.filteredItems(this.state.query.toLowerCase())}
            itemRenderer={this.props.itemRenderer}
            update={this.props.update}
            itemDisableActions={this.props.itemDisableActions}
          >
            {this.props.children}
          </List>
        </div>
      </div>
    )
  }

  renderSearchbar() {
    return (
      <SearchField
        onChange={this.onChange.bind(this)}
        placeholder={this.props.t("search")}
      />
    )
  }
}

export default withTranslation()(SearchableList)



// WEBPACK FOOTER //
// ./src/components/SearchableList.js